import React, { useEffect, useState } from "react";
import "./MobileViewOrder.css";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";
import AirplanemodeActiveIcon from "@mui/icons-material/AirplanemodeActive";
import { useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  selectViewOrderDetail,
  viewOrderDetailAsync,
} from "../../features/cartPage/OrderSlice";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Link } from "react-router-dom";
import { formatWithCommasWithDecimal } from "../../utils/utils";
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { EVENTS } from "../../analytics/events";
import { trackEvent } from "../../analytics/gtag";
import { selectUser } from "../../features/auth/authSlice";

function MobileViewOrder() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const orderDetail = useSelector(selectViewOrderDetail);
  const order_ID = useParams();
  const userDetail = useSelector(selectUser);
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      handleOpen();
      dispatch(viewOrderDetailAsync(order_ID && order_ID?.order_ID));
      handleClose();
    };
    fetchData();
    return () => clearTimeout(2000);
  }, [dispatch, order_ID]);

  const calculateTotalProductCost = (products) => {
    let totalCost = 0;
    if (products) {
      for (const product of products) {
        totalCost += parseInt(product?.NDP_price && product?.NDP_price);
        // *product?.quantity;
      }
    }
    return totalCost;
  };
  const calculateTotalGST = (products) => {
    let totalGST = 0;
    if (products) {
      for (const product of products) {
        // Use offer price if available, otherwise use NDP price
        const price = parseFloat(product?.NDP_price);
        const gstRate = product?.GST;

        // Calculate the price excluding GST
        const priceExcludingGST = price / (1 + gstRate / 100);

        // Calculate the GST amount
        const gstAmount = price - priceExcludingGST;

        // Accumulate total GST
        totalGST += gstAmount;
      }
    }
    return totalGST;
  };

  const [selectedInvoice, setSelectedInvoice] = React.useState("");

  const handleDownloadInvoice = async (invoiceNo) => {
    try {
      if (!invoiceNo) throw new Error("Invalid invoice number");

      // 1️⃣ Generate the invoice first
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}genrate_invoice/${invoiceNo}`, {
        method: "GET",
      });

      if (!response.ok) {
        throw new Error("Failed to generate invoice");
      }

      // 2️⃣ Wait briefly to ensure file upload completes
      await new Promise((resolve) => setTimeout(resolve, 1000));

      // 3️⃣ Construct the final download URL
      const invoiceUrl = `https://cyclecircle.blr1.digitaloceanspaces.com/${process.env.REACT_APP_IMAGE_BASE}_INVOICE/${invoiceNo}.pdf`;

      // 4️⃣ Create and trigger a temporary download link
      const link = document.createElement("a");
      link.href = invoiceUrl;
      link.setAttribute("download", `${invoiceNo}_invoice.pdf`);
      document.body.appendChild(link);
      link.click();

      // 5️⃣ Clean up
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error generating or downloading invoice:", error);
    }
  };

  const getDisplayName = (filename) => {
    if (filename.includes("CCIN-")) {
      return filename.split("CCIN-")[1].split(".")[0]; // Extract text after 'CCIN-' and before '.'
    }
    return "CycleCircle Invoice";
  };
  const handleChangeInvoice = (event) => {
    const invoiceNo = event.target.value;
    setSelectedInvoice(invoiceNo);
    handleDownloadInvoice(invoiceNo);
  };

  const filterInvoices = () => {
    return orderDetail?.Invoice || [];
  };

  return (
    <div className="mobile-view-order-container">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open} // Show backdrop when either open or filtering state is true
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className="mobile-view-order-header">
        <div className="mobile-view-order-header-left">
          <ChevronLeftOutlinedIcon onClick={() => navigate("/user/orders")} />
          <span className="mobile-view-order-header-left-order-id">
            Order ID: #{orderDetail && orderDetail?.order_no}
          </span>
        </div>
        <div className="view-order-detail-header-right-div !w-[100px]">
          <FormControl fullWidth variant="outlined" size="small">
            <InputLabel id="invoice-select-label">
              <Box display="flex" alignItems="center">
                Invoice
              </Box>
            </InputLabel>
            <Select
              labelId="invoice-select-label"
              value={selectedInvoice}
              onChange={handleChangeInvoice}
              label="Invoice"
            >
              {filterInvoices().map((invoiceFile) => (
                <MenuItem key={invoiceFile} value={invoiceFile}>
                  {getDisplayName(invoiceFile)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>
      <div className="mobile-view-order-date-container">
        <span className="mobile-view-order-order-date">
          Order Date:{" "}
          <b>
            {orderDetail &&
              // new Date(orderDetail?.order_date).toLocaleDateString()}
              new Date(orderDetail?.order_date).toLocaleDateString("en-US", {
                month: "numeric",
                day: "numeric",
                year: "numeric",
              })}
          </b>
        </span>
        <div className="mobile-view-order-delivery-order-date">
          <AirplanemodeActiveIcon />{" "}
          <span>
            Est. delivery:{" "}
            {new Date(
              new Date(orderDetail?.order_date).getTime() +
              7 * 24 * 60 * 60 * 1000
            ).toLocaleDateString("en-US", {
              day: "numeric",
              month: "numeric",
              year: "numeric",
            })}
          </span>{" "}
        </div>
      </div>
      <div className="mobile-view-order-product-container">
        <div className="mobile-view-order-product-total-number">
          {" "}
          Items (
          {orderDetail &&
            orderDetail?.orderDetails &&
            orderDetail?.orderDetails?.length}
          )
        </div>
        <div className="mobile-view-order-product-main-container">
          {orderDetail &&
            orderDetail?.orderDetails &&
            orderDetail?.orderDetails?.map((product) => (
              <div
                className={`my-order-each-order-product-details-container`}
                key={product.item_no_SKU}
              >
                <div className="my-order-each-order-product-top-container">
                  <div className="my-order-each-order-product-left-container">
                    <img
                      loading="lazy"
                      src={`https://cyclecircle.blr1.cdn.digitaloceanspaces.com/${process.env.REACT_APP_IMAGE_BASE}_PRODUCTS_IMAGE/${product.image}`}
                      alt=""
                      className="my-order-each-order-product-left-img"
                      onClick={() => {
                        navigate(`/product/${product?.product_id}`);
                        // Analytics
                        trackEvent({
                          action: EVENTS.VIEW_PRODUCT,
                          category: "Product",
                          label: `User Visited Product ${product?.product_id}`,
                          value: userDetail?.PhoneNumber,
                        });
                      }}
                    />
                  </div>
                  <div className="my-order-each-order-product-right-container">
                    <img
                      loading="lazy"
                      src={`https://cyclecircle.blr1.cdn.digitaloceanspaces.com/${process.env.REACT_APP_IMAGE_BASE}_MANUFACTURE_IMAGE/${product && product?.manufacture_images
                        }`}
                      alt=""
                      className="my-order-each-order-product-manufacture-img"
                    />
                    <span className="my-order-each-order-product-name">
                      {product.prod_name}
                    </span>
                    <span className="my-order-each-order-product-tech">
                      {product.prodTech &&
                        product.prodTech
                          .slice(0, 1)
                          .map((tech, index) => (
                            <span key={index}>{tech} |</span>
                          ))}
                    </span>
                    <div className="my-order-each-order-product-qty-varient-details-container">
                      <span className="my-order-each-order-product-qty">
                        Qty:&nbsp;<b>{product && product?.quantity}</b>
                      </span>
                      <span className="my-order-each-order-product-size">
                        Size: &nbsp;
                        <b>
                          {product && product?.size_name
                            ? product?.size_name?.slice(0, 10)
                            : "---"}
                        </b>
                      </span>
                      <span className="my-order-each-order-product-size">
                        Color: &nbsp;
                        <b>
                          {product && product?.colour_name
                            ? product?.colour_name?.slice(0, 10)
                            : "---"}
                        </b>
                      </span>
                    </div>
                  </div>
                </div>
                {/* <div className="my-order-each-order-product-review-container">
                  <span className="my-order-each-order-prduct-review">
                    Write a review
                  </span>
                  <span className="my-order-each-order-product-return">
                    Return this Item
                  </span>
                </div> */}
              </div>
            ))}
        </div>
        <div className="mobile-view-order-order-summary-container">
          <span className="mobile-view-order-order-summary-heading">
            Order Summary
          </span>
          <hr />
          <div className="mobile-view-order-order-summary-each-container">
            <span>Order Status</span>
            <span>
              {orderDetail?.orderStatus?.status === "Created"
                ? "Pending"
                : orderDetail?.orderStatus?.status === "Success"
                  ? "Delivered"
                  : orderDetail?.orderStatus?.status}
            </span>
          </div>

          <div className="mobile-view-order-order-summary-each-container">
            <span>Order ID</span>
            <span>#{orderDetail && orderDetail?.order_no}</span>
          </div>
          <div className="mobile-view-order-order-summary-each-container">
            <span>Order Placed</span>
            <span>
              {orderDetail &&
                orderDetail?.order_date &&
                new Date(orderDetail?.order_date).toLocaleDateString("en-US", {
                  month: "long",
                  day: "numeric",
                  year: "numeric",
                })}
            </span>
          </div>
          <div className="mobile-view-order-order-summary-each-container">
            <span>Estimated Delivery Date</span>
            <span>
              {new Date(
                new Date(orderDetail?.order_date).getTime() +
                7 * 24 * 60 * 60 * 1000
              ).toLocaleDateString("en-US", {
                day: "numeric",
                month: "long",
                year: "numeric",
              })}
            </span>
          </div>
          <hr />
          <div className="mobile-view-order-order-summary-each-container">
            <span>Total Products</span>
            <span>{orderDetail && orderDetail?.orderDetails?.length}</span>
          </div>
          <div className="mobile-view-order-order-summary-each-container">
            <span>
              {" "}
              Total Product Cost{" "}
              <b style={{ fontWeight: "400", fontSize: "2.8vw" }}>
                (incl. of all Taxes)
              </b>
            </span>
            <span>
              ₹
              {formatWithCommasWithDecimal(
                calculateTotalProductCost(
                  orderDetail &&
                  orderDetail?.orderDetails &&
                  orderDetail?.orderDetails
                )
              )}
            </span>
          </div>
          <div className="mobile-view-order-order-summary-each-container">
            <span>Shipping & Handling</span>
            <span>
              ₹
              {formatWithCommasWithDecimal(
                orderDetail && orderDetail?.Shipping_Amount === null
                  ? "0.00"
                  : orderDetail?.Shipping_Amount
              )}
            </span>
          </div>
          <div className="mobile-view-order-order-summary-each-container">
            <span>Discount</span>
            <span>
              -₹
              {formatWithCommasWithDecimal(
                orderDetail && orderDetail?.Discount_Amount === null
                  ? "0.00"
                  : orderDetail?.Discount_Amount
              )}
            </span>
          </div>

          <div className="mobile-view-order-order-summary-each-container">
            <span>GST</span>
            <span>
              {" "}
              ₹
              {formatWithCommasWithDecimal(
                calculateTotalGST(orderDetail && orderDetail?.orderDetails)
              )}
            </span>
          </div>
          {/* <hr /> */}
          <div className="mobile-view-order-order-summary-total-price-container">
            <span>Total (₹)</span>
            <span>
              ₹
              {orderDetail?.TotalAmount ? formatWithCommasWithDecimal(
                orderDetail && orderDetail?.TotalAmount
              ) : 0}
            </span>
          </div>
        </div>
        <div className="mobile-view-order-payment-method-container">
          <span>Payment Method</span>
          <img
            loading="lazy"
            src="https://myhq.s3.amazonaws.com/benefits/5dfba19e8236fc88159e1a2d.png"
            alt=""
          />
        </div>
        <div className="mobile-view-order-booking-address-container">
          <div className="mobile-view-order-support-address-div">
            <span className="mobile-view-order-support-address-heading">
              Support Address
            </span>
            <span className="mobile-view-order-support-address-main">
              Radkaat Ventures Private Limited, 1st Floor, Unit no.124, Paras
              Trade Centre, Gurgaon Faridabad Road, Gwal Pahari, Gurugram,
              District, Gurugram, Haryana 122003
            </span>
          </div>
          <div className="mobile-view-order-booking-address">
            <span className="mobile-view-order-booking-address-heading">
              Delivery Address
            </span>
            <span className="mobile-view-order-booking-address-main">
              {orderDetail && orderDetail?.Address?.FirstName}{" "}
              {orderDetail && orderDetail?.Address?.LastName} ,{" "}
              {orderDetail && orderDetail?.Address?.address_1},{" "}
              {orderDetail && orderDetail?.Address?.address_2},{" "}
              {orderDetail && orderDetail?.Address?.city},<br />
              {orderDetail && orderDetail?.Address?.district},{" "}
              {orderDetail && orderDetail?.Address?.pin_code},{" "}
              {orderDetail && orderDetail?.Address?.stateName},{" "}
              {orderDetail && orderDetail?.Address?.PhoneNumber}
            </span>
          </div>
        </div>
      </div>
      <div className="mobile-view-order-have-question-container">
        <div className="mobile-view-order-have-question-main-container">
          <span className="mobile-view-order-have-question-heading">
            Have Questions About Your Order?
          </span>
          <span className="mobile-view-order-have-question-supporting-text">
            {" "}
            Our Friendly support team is here for question about status of your
            order,billing,shipping and other order related questions
          </span>
          <Link
            to="https://wa.me/9418696322"
            target="_blank"
            className="mobile-view-order-have-question-contact-support-span"
          >
            Contact Support
          </Link>
        </div>
      </div>
      {/* <div className="mobile-view-order-track-order-order-again-container">
        {orderDetail && orderDetail?.order_no && (
          <a
            href={`${process.env.REACT_APP_TRACKING_ORDER}${orderDetail?.order_no}`}
            target="_blank"
            rel="noreferrer"
            className="mobile-track-order-btn"
          >
            Track Order
          </a>
        )}
        <span className="mobile-view-order-order-again">Order Again</span>
      </div> */}
    </div>
  );
}

export default MobileViewOrder;
